import script from "./ProfileBankAccounts.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileBankAccounts.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileBankAccounts.vue?vue&type=style&index=0&id=13b44878&lang=css"

const __exports__ = script;

export default __exports__